import marked from 'marked'

export const createMarkup = (unsafe, options = {}) => {
  const renderer = new marked.Renderer()

  if (options.renderInline) {
    // Render input as is, without wrapping <p> tags
    renderer.paragraph = text => text
  }

  if (options.disableAutolink) {
    // Disables autolinking
    renderer.link = text =>
      text
        .replace(/mailto:/g, '')
        .replace(/^https?:\/\//g, '')
        .replace(/www./g, '')
  }

  if (options.openLinksInNewTab) {
    renderer.link = (href, _, text) => {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`
    }
  }

  const config = {
    renderer,
    gfm: true,
    breaks: true,
    headerIds: true,
    mangle: true,
    smartypants: true,
    xhtml: true,
  }

  // Remove script tags
  const almostSafe = unsafe.replace(/<script[^>]*>(?:(?!<\/script>)[^])*<\/script>/g, '')

  // Remove unsafe attributes
  const safe = almostSafe.replace(/on(click|load|error)=[^\s/]*/g, '')

  // Parse Markdown
  const parsedStr = marked(safe, config)

  return { __html: parsedStr }
}
